import tippy from 'tippy.js';
import Swal from 'sweetalert2';
import { sponsors }  from '~/assets/icons/js/sponsors';
import { externalLink }  from '~/assets/icons/js/externalLink';
export default (editor, opts = {}) => {

    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('link');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    /* Component trigger sponsors */
    let model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults, 
            /* draggable:false, */
            droppable: false,
            copyable: false,
            badgable:false,
            attributes:{
                'data-slg-type':'C-TRIGGER-SPONSORS',
                'data-target': "#sponsor",
                'data-toggle': "modal",
            },
            style:{
                display:'inline'
            },
            content:"Trigger sponsors",
            traits: [
                {
                    type: 'text',
                    name: 'content', 
                    label: 'Content', 
                    placeholder: 'Insert text', 
                    changeProp: 1,
                  }
                
            ] 
        }  
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-TRIGGER-SPONSORS")
                return { type:'C-TRIGGER-SPONSORS' }
        }
    });

    
    let view = VIEW.extend({
        init(){
            this.createCustomMenu();
        },
        async onRender(){
            
        },
        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
        createCustomMenu: function(){
            let el = this.el;
            var self = this;
            let tooltip_html = /*html*/
            `
            <div id="template">
                <ul class="list-toggle">
                    <li class="item component-modal">
                        ${externalLink}
                    </li>
                </ul>
            </div>
            `
            const instance = tippy(el, {
                content: tooltip_html,
                allowHTML: true,
                trigger: 'click',
                theme: 'light',
                interactive: true,
                placement: 'auto',
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    let item_component_modal = instance.popper.querySelector('.item.component-modal');
                    
                    item_component_modal.addEventListener('click',(e) =>{
                        e.preventDefault();
                        let canvas_document = editor.Canvas.getDocument();
                        let modal = canvas_document.querySelector('#sponsor');
                        modal.classList.add('show');
                        modal.style.display = "block";

                        let modal_backdrop = document.createElement('div');
                        modal_backdrop.classList.add('modal-backdrop', 'fade', 'show');

                        
                        canvas_document.body.appendChild(modal_backdrop);
                        instance.hide();
                    });
                },
            });
            
            
        },
    });
    
    DOMC.addType('C-TRIGGER-SPONSORS',{
      model,
      view
    });

    BM.add('B-TRIGGER-SPONSORS', {
        label:"SPONSORS",
        content: { 
            type: 'C-TRIGGER-SPONSORS',
        },
        media:sponsors,
        category:"LEADGREASE INTEGRATION"
    });

    editor.on('block:drag:stop', async (model) => {
        if(model && model.is('C-TRIGGER-SPONSORS')){
            let wrapper = editor.getWrapper();
            let find = wrapper.findType('C-MODAL-SPONSORS');
            if(find.length >= 1){
                Swal.fire({
                    icon:'warning',
                    title: 'Already created!',
                    text: "There can only be one sponsor component",
                    heightAuto:false,
                    
                });

                let result = await Swal.fire({
                    title: 'Modal sponsors already created!',
                    icon: 'warning',
                    text: "You want to recreate the component",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, create it!'
                })
                if(result.isConfirmed){
                    find[0].replaceWith({
                        type: 'C-MODAL-SPONSORS'
                    });
                }
                return;
            }else{
                editor.addComponents({
                    type: 'C-MODAL-SPONSORS'
                },{at:0});
            }
        }
            
    });
    
};
  